import { useRouteContext } from '@tanstack/react-router';

export function useBookingRepository() {
  const repository = useRouteContext({
    strict: false,
    select: (context) => context.bookingRepository,
  });

  if (!repository) throw new Error('BookingRepository must be provided in context');

  return repository;
}
